import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import WindBallShowcase from "../pages/WindBallShowcase";
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import "./HeroSection.css";

const HeroSection = () => {
  const { t, locale } = useI18n();
  const handleScrollToTimeline = useCallback((event) => {
    event.preventDefault();
    const target = document.getElementById("champion-timeline");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <section className="hero-section" aria-labelledby="hero-headline">
      <div aria-hidden className="hero-glow hero-glow--gold" />
      <div aria-hidden className="hero-glow hero-glow--ink" />

      <div className="hero-grid">
        <motion.div
          className="hero-copy"
          initial={false}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.05 }}
        >
          <p className="hero-eyebrow">{t('hero.eyebrow')}</p>
          <h1 id="hero-headline" className="hero-headline">
            {t('hero.titleFirst')}
            <br />
            <span className="hero-headline-accent">{t('hero.titleSecond')}</span>
          </h1>
          <p className="hero-sub">
            {t('hero.subtitle')}
          </p>

          <div className="hero-cta-row">
            <Link to={getLocalizedPath('/store', locale)} data-analytics-target="hero_store" className="hero-cta hero-cta--primary">
              {t('home.shop')}
            </Link>
            <a
              href="#champion-timeline"
              onClick={handleScrollToTimeline}
              className="hero-cta hero-cta--secondary"
            >
              {t('hero.watch')} <span aria-hidden>↗</span>
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={false}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <WindBallShowcase variant="hero" />
        </motion.div>
      </div>

      <a
        href="#trust-bar"
        className="hero-scroll-cue"
        aria-label={t('hero.scroll')}
      >
        <span aria-hidden>↓</span>
      </a>
    </section>
  );
};

export default HeroSection;
